import Vue from 'vue'
import moment from 'moment'

export default function (value, formatTo, formatFrom) {
  const locale = 'ru'

  formatFrom = _.get(Vue.config.format, formatFrom, formatFrom)
  formatTo = _.get(Vue.config.format, formatTo, formatTo)

  const date = moment(value, formatFrom)

  return date.isValid() ? date.locale(locale).format(formatTo) : value
}
